import { DatePicker } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';
import { forwardRef } from 'react';
import { XmButton } from 'src/component/button/XmButton';
import type { XmRangeDatePickerProps, XmRangeDatePickerRef } from './rangePickerAntd';
import { shownRange } from './rangePickerState';
import { useCandidateCells } from './useCandidateCells';
import { useRangeHandle } from './useRangeHandle';
import { useRangePickerAdapter } from './useRangePickerAdapter';

const { RangePicker } = DatePicker;

const DeferredRangePicker = forwardRef<XmRangeDatePickerRef, XmRangeDatePickerProps>((props, ref) => {
  const picker = useRangeHandle(ref);
  const adapter = useRangePickerAdapter(props, picker);
  const { state } = adapter;
  const cellRender = useCandidateCells({ current: shownRange(state), active: state.active, open: state.open, props });
  const panelRender: RangePickerProps['panelRender'] = node => (
    <div className="xm-range-picker-panel">{props.panelRender ? props.panelRender(node) : node}</div>
  );
  const okText = props.locale?.lang.ok ?? 'OK';
  const renderExtraFooter: RangePickerProps['renderExtraFooter'] = mode => (
    <>
      {props.renderExtraFooter?.(mode)}
      {/* ignoreReadonly: the picker only narrows what is shown, so a readonly user must still be able to apply a range. */}
      <XmButton ignoreReadonly type="primary" size="small" className="xm-range-picker-ok" {...adapter.okButtonProps}>{okText}</XmButton>
    </>
  );
  return (
    <div className="xm-range-picker" {...adapter.wrapperProps}>
      <RangePicker
        {...props}
        {...adapter.pickerProps}
        ref={picker}
        needConfirm={false}
        previewValue={false}
        cellRender={cellRender}
        panelRender={panelRender}
        renderExtraFooter={renderExtraFooter}
      />
    </div>
  );
});

export default DeferredRangePicker;
